import {emotionStyled} from '@packages/utilities/styled';
import {buttonGroupStyles} from './ButtonGroup.styles';

export const ButtonGroupView = emotionStyled('div')({
  boxSizing: 'border-box',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  ...buttonGroupStyles,
});
